import mitt, { Emitter } from "mitt";
import AfterOrderPay from "../events/Checkout/AfterOrderPay";
import BeforeDeliveryStepContinue from "../events/Checkout/BeforeDeliveryStepContinue";
import AfterCheckoutError from "../events/Checkout/AfterCheckoutError";

export type Events = {
    afterOrderPay: AfterOrderPay;
    beforeDeliveryStepContinue: BeforeDeliveryStepContinue;
    afterCheckoutError: AfterCheckoutError;
};

const CheckoutCustomizationEventBus: Emitter<Events> = mitt<Events>();

export default CheckoutCustomizationEventBus;
